var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import DOMPurify from 'dompurify';
import QuestionnaireOrg from "../../../organisms/jsQuestionnaire/jsQuestionnaire";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GlobalAction, GlobalFormAction, } from "../../../../redux/actions/job_seeker_questionnaire";
import { questionnaireTimer } from "../../../../utils/QuestionnaireTimer";
import { getQuestionnaireAttemptVariant, getQuestionnaireProgressWidth, isMilestoneAttempt, } from "../../../../utils/questionnaireProgress";
import { updateNeedsQuestionnaire } from "../../../../redux/actions/dashboard";
/**
 * The Global Questionnaire Page
 * This will need to call all relevant APIs to get the values.
 * @param props
 * @returns
 */
function GlobalQuestionnaire() {
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var _a = useState(''), error = _a[0], setError = _a[1];
    var _b = useState(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    //using selector hook to fetch data from the reducer
    var _c = useSelector(function (state) { return state.rootReducer.JobSeekerQuestionnaireReducer; }), globalData = _c.globalData, error_global = _c.error_global, loading = _c.loading, globalFormData = _c.globalFormData, success_global_form = _c.success_global_form;
    var loginData = useSelector(function (state) { return state.rootReducer.userReducer; }).loginData;
    useEffect(function () {
        questionnaireTimer.startSection("Overall Expectations");
        // Antecedents prefetches this section already; only fetch if it's
        // not already cached in the store (e.g. direct navigation to this page).
        if (!globalData || globalData.length === 0) {
            dispatch(GlobalAction());
        }
    }, [dispatch]);
    //function to submit the input user data
    var handleFormSubmit = function (formData) {
        questionnaireTimer.endSection("Overall Expectations");
        var sanitizedData = Object.keys(formData).reduce(function (acc, key) {
            acc[key] = DOMPurify.sanitize(formData[key]);
            return acc;
        }, {});
        var submissionData = __assign({}, sanitizedData);
        // Only record Q1 completion time here; the milestone attempt and Q3
        // (formerly Q2) both continue to overall_experience_2
        if (!isNonFirstAttempt) {
            var timingData = questionnaireTimer.onQuestionnaireComplete();
            console.log("\u2705 Q1 jobseeker questionnaire time: ".concat((timingData.totalSeconds / 60).toFixed(2), " minutes"));
            submissionData.completion_time_seconds = Math.round(timingData.totalSeconds);
            questionnaireTimer.clearTimings();
        }
        setIsSubmitting(true);
        dispatch(GlobalFormAction(submissionData, loginData));
    };
    var quesAttemptDetails = useSelector(function (state) { return state.rootReducer.dashboardReducer.quesAttemptDetails; });
    var isNonFirstAttempt = !!((quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.second_attempt_ready) ||
        (quesAttemptDetails === null || quesAttemptDetails === void 0 ? void 0 : quesAttemptDetails.milestone_questionnaire_ready));
    var milestoneAttempt = isMilestoneAttempt(quesAttemptDetails);
    var handleBackBtn = function () {
        navigate("/questionnaire/progression");
    };
    useEffect(function () {
        if (success_global_form && isSubmitting) {
            if (quesAttemptDetails && isNonFirstAttempt) {
                navigate(milestoneAttempt
                    ? "/questionnaire/overallExperience"
                    : "/questionnaire/adviserFeedback");
            }
            else {
                // The first part of the questionnaire (antecedents-global) is now
                // complete, regardless of whether the obligations follow-up is
                // completed or skipped from here.
                dispatch(updateNeedsQuestionnaire(false));
                navigate("/questionnaire/transition");
            }
        }
    }, [success_global_form, isSubmitting, quesAttemptDetails, isNonFirstAttempt, milestoneAttempt, dispatch, navigate]);
    return (_jsxs("div", __assign({ className: "" }, { children: [error && _jsx("div", __assign({ className: "error-message" }, { children: error })), _jsx(QuestionnaireOrg, { title: "Overall Expectations", content: "As a participant on this programme, you will be interacting with your adviser. \n        In order to ensure that you get the best from the relationship with your adviser, we want to understand what \n        you feel you have committed to do, but also what they have committed to do, to support to towards employment. \n        Please respond truthfully and trust your initial reactions to the following statements.", data: globalData, responses: globalFormData, loading: !globalData || globalData.length === 0, handleSubmit: handleFormSubmit, handleBackBtn: handleBackBtn, classname: "global-w", width: getQuestionnaireProgressWidth("global", getQuestionnaireAttemptVariant(quesAttemptDetails)) })] })));
}
export default GlobalQuestionnaire;
